import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ArticlecategoriesList from './ArticlecategoriesList/ArticlecategoriesList';
import ArticlecategoryShow from './ArticlecategoryShow/ArticlecategoryShow';
import ArticlecategoryEdit from './ArticlecategoryEdit/ArticlecategoryEdit';
import ArticlecategoryCreate from './ArticlecategoryCreate/ArticlecategoryCreate';
import ArticlecategoryDelete from './ArticlecategoryDelete/ArticlecategoryDelete';

const Articlecategories = ({ match }) => {
    return (
        <div className="Articlecategories">
            <ContainerWrapper container="articlecategories">
                <Route exact path={ match.path } component={ArticlecategoriesList} />
                <Route exact path={ `${ match.url }/new` } component={ArticlecategoryCreate} />
                <Route exact path={ `${ match.url }/show/:articlecategoryId` } component={ArticlecategoryShow} />
                <Route exact path={ `${ match.url }/edit/:articlecategoryId` } component={ArticlecategoryEdit} />
                <Route exact path={ `${ match.url }/delete/:articlecategoryId` } component={ArticlecategoryDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Articlecategories;
